import { createContext } from "../ContextSelector";
var ExpandedRowContext = createContext(null);
export default ExpandedRowContext;